import { getRecordService } from '../services'

export default (rut) => {
  return new Promise(async (resolve, reject) => {
    await getRecordService.read(rut)
      .then(response => resolve(response.data))
      .catch(err => reject({ error: true }))
  })
}
